import clsx from 'clsx';

// Types
import type { ButtonIconProps } from '@/components/layouts/LayoutPlatform/components/PageHeaderRecap/ButtonIcons/ButtonIcon';
// Components
import ButtonIcon from '@/components/layouts/LayoutPlatform/components/PageHeaderRecap/ButtonIcons/ButtonIcon';

export const BUTTON_ICONS_SEPARATOR = 'separator';

export type ButtonIconsActionType = Omit<ButtonIconProps, 'smaller'> & {
    id: string;
    available?: boolean;
    'data-testid'?: string;
};

type ButtonIconsElementProps = {
    action: ButtonIconsActionType;
    smaller?: boolean;
};

const ButtonIconsElement = ({ action, smaller }: ButtonIconsElementProps) => {
    if (action.icon === BUTTON_ICONS_SEPARATOR) {
        return (
            <span
                data-testid="button-icons-separator"
                className={clsx('block w-0.5 bg-icoGray-300 dark:bg-icoDarkMode-beton', {
                    'h-4': !smaller,
                    'h-3': smaller
                })}
            />
        );
    }
    return <ButtonIcon {...action} smaller={smaller} />;
};

type ButtonIconsProps = {
    actions: ButtonIconsActionType[];
    smaller?: boolean;
};

const ButtonIcons = ({ actions, smaller }: ButtonIconsProps) => (
    <div className={clsx('flex', { 'space-x-5': !smaller, 'space-x-4': smaller })}>
        {actions.map((action) => {
            if (action.available === false) return null;
            return <ButtonIconsElement key={action.id} action={action} smaller={smaller} />;
        })}
    </div>
);

export default ButtonIcons;
